import { cloneDeep } from "lodash";

const SET_NOTIFICATIONS = "app/notifications/SET_NOTIFICATIONS";
const SET_SYSTEM_NOTIFICATIONS = "app/notifications/SET_SYSTEM_NOTIFICATIONS";
const SET_NOTIFICATION_TO_EDIT = "app/notifications/SET_NOTIFICATION_TO_EDIT";
const SET_NOTIFICATION_IMAGE = "app/notifications/SET_NOTIFICATION_IMAGE";
const RESET_NOTIFICATIONS = "app/notifications/RESET_NOTIFICATIONS";
const RESET_SYSTEM_NOTIFICATIONS = "app/notifications/RESET_SYSTEM_NOTIFICATIONS";
const SET_LOADING = "app/notifications/SET_LOADING";
const SET_REFRESH = "app/notifications/SET_REFRESH";
const SET_ERROR = "app/notifications/SET_ERROR";

const initialState = {
  notifications: null,
  systemNotifications: null,
  notificationToEdit: null,
  loading: false,
  refresh: false,
  error: null
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_NOTIFICATIONS: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        notifications: action.payload
      };
    }

    case RESET_NOTIFICATIONS: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        notifications: null
      };
    }

    case SET_SYSTEM_NOTIFICATIONS: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        systemNotifications: action.payload
      };
    }

    case RESET_SYSTEM_NOTIFICATIONS: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        systemNotifications: null
      };
    }

    case SET_NOTIFICATION_IMAGE: {
      const clonedState = cloneDeep(state);
      const { notificationName, imageFile, imageSrc, isSystemNotification } = action.payload ?? {};

      let newNotifications = isSystemNotification
        ? clonedState.systemNotifications
        : clonedState.notifications ?? [];

      const idx = newNotifications.findIndex(
        (notification) => notification.notificationName === notificationName
      );

      if (idx !== -1) {
        newNotifications = [
          ...newNotifications.slice(0, idx),
          { ...newNotifications[idx], imageFile, imageSrc },
          ...newNotifications.slice(idx + 1)
        ];
      }

      const updatedNotifications = isSystemNotification
        ? clonedState.notifications
        : newNotifications;
      const updatedSystemNotifications = isSystemNotification
        ? newNotifications
        : clonedState.systemNotifications;

      return {
        ...clonedState,
        notifications: updatedNotifications,
        systemNotifications: updatedSystemNotifications
      };
    }

    case SET_REFRESH: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        refresh: action.payload
      };
    }

    case SET_LOADING: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        loading: action.payload
      };
    }

    case SET_ERROR: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        error: action.payload
      };
    }

    case SET_NOTIFICATION_TO_EDIT: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        notificationToEdit: action.payload
      };
    }

    default: {
      return state;
    }
  }
}

export const setNotifications = (notifications) => ({
  type: SET_NOTIFICATIONS,
  payload: notifications
});

export const setSystemNotifications = (systemNotifications) => ({
  type: SET_SYSTEM_NOTIFICATIONS,
  payload: systemNotifications
});

export const setNotificationToEdit = (notification) => ({
  type: SET_NOTIFICATION_TO_EDIT,
  payload: notification
});

export const setNotificationImage = (notificationImage) => ({
  type: SET_NOTIFICATION_IMAGE,
  payload: notificationImage
});

export const resetNotifications = () => ({ type: RESET_NOTIFICATIONS });

export const resetSystemNotifications = () => ({ type: RESET_SYSTEM_NOTIFICATIONS });

export const setLoading = (loading) => ({ type: SET_LOADING, payload: loading });

export const setRefresh = (refresh) => ({ type: SET_REFRESH, payload: refresh });

export const setError = (error) => ({ type: SET_ERROR, payload: error });
